import React from "react";
import { Col } from "reactstrap";
import classNames from "classnames";
// Used all over the place, including a slew of custom machine setup rows,
// and the following setups: DS-21/31, Saco Ring Twister, Saurer Alma TC2, 
// Taining 35AFP, Taining 35AR, Taining 35A Tube, UT50/60-733, and Xorella

export default function ColPrompt({ title, hideColon, bold = false, description = false, sizeProp }) {
   return (
      <Col xxl={sizeProp || 3} xl={3} lg={3} className={classNames("", { "text-white": !bold })}>
         <h5 className={classNames("text-end", { "fw-bold": bold })}>
            {title}{hideColon ? false : ": "}{description ? `(${description})` : description}
         </h5>
      </Col>
   );
}